// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"adaeb6d9","167":"18e83b45","219":"8402b9d8","284":"d4fd7800","327":"037d735c","484":"d217db64","621":"507c2b57","729":"52329aa2","895":"0871894e","942":"eb982011","975":"65589191"}[chunkId] + ".chunk.js";
};